import React from "react";

const OmsSpinnerData = ({ size = 42, color = "#2563eb" }) => {
  return (
    <div className="omsspinnerdata-page">
      <div
        className="omsspinnerdata"
        style={{
          width: size,
          height: size,
          borderTopColor: color,
        }}
      />
    </div>
  );
};

export default OmsSpinnerData;
